const SIZES = {
  header: { img: "h-[52px] sm:h-[68px] lg:h-[104px]", tag: "text-[6px] sm:text-[7.5px] lg:text-[10px]", line: "w-2.5 sm:w-4 lg:w-7" },
  footer: { img: "h-20", tag: "text-[7px]", line: "w-4" },
  admin: { img: "h-12", tag: "text-[5px]", line: "w-2" },
};

export const Logo = ({ size = "header", className = "" }) => {
  const s = SIZES[size] || SIZES.header;
  return (
    <span className={`inline-flex flex-col items-center ${className}`} data-testid={`logo-${size}`}>
      <img src="/assets/logo.webp" alt="The Nordic Vision" width={482} height={360} className={`${s.img} w-auto drop-shadow-[0_6px_18px_rgba(0,0,0,0.45)]`} data-testid={`${size}-logo-image`} />
      <span className={`-mt-0.5 inline-flex items-center gap-1.5 whitespace-nowrap font-medium uppercase tracking-[0.3em] text-[#41535F] ${s.tag}`} data-testid={`${size}-logo-slogan`}>
        <span className={`h-px bg-gradient-brand ${s.line}`} aria-hidden="true" />
        Crafting Tomorrow
        <span className={`h-px bg-gradient-brand ${s.line}`} aria-hidden="true" />
      </span>
    </span>
  );
};

export default Logo;
